export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '欧美一区二区平台提供哪些内容？',
    answer: '欧美一区二区是专业的影视内容分区导航平台，精准划分欧美一区和二区资源，涵盖院线大片、高分剧集、独立电影、纪录片、经典老片等多种类型。我们提供详细的影片介绍、分区导航、高清资源指引，帮助您快速找到想看的欧美影视内容。',
  },
  {
    question: '欧美一区和二区有什么区别？',
    answer: '欧美一区主要汇聚好莱坞热门大片、高分剧集和主流商业电影，内容覆盖面广、更新速度快；欧美二区则专注于独立电影、文艺片、纪录片和小众精品，更注重内容深度和艺术价值。两个分区各有侧重，满足不同观众的观影需求。',
  },
  {
    question: '平台上的内容更新频率如何？',
    answer: '我们的编辑团队每日更新，紧跟欧美影视最新动态。新片上映、剧集更新、电影节资讯等都会在第一时间整理上线，确保您不会错过任何精彩内容。',
  },
  {
    question: '如何快速找到我感兴趣的欧美影视资源？',
    answer: '您可以通过首页的分类导航按类型（动作冒险、科幻奇幻、剧情悬疑、喜剧爱情等）浏览，也可以使用分区筛选（欧美一区/二区）精准定位。每篇文章都标注了详细的标签和分类信息，方便您快速检索。',
  },
  {
    question: '平台的内容是否免费浏览？',
    answer: '欧美一区二区平台上的所有影视介绍、影评、资讯等内容完全免费浏览。我们是一个内容导航和信息聚合平台，不直接提供影片播放服务，但会为您指引高清资源的查找方向。',
  },
  {
    question: '如何联系我们？',
    answer: '您可以通过关于我们页面的联系方式与我们取得联系，包括电子邮件、社交媒体等渠道。我们欢迎影迷朋友提供内容建议和反馈意见，共同打造更好的欧美影视导航平台。',
  },
];